import { FormattedMessage, useIntl } from 'react-intl'

import {
  TwofaButtonsContainer,
  TwofaContainer,
  TwoFaSubTitle,
  TwofaTitle
} from '../../styled-components'
import {
  buttonSizeOptions,
  buttonVariantOptions
} from '../../../../components/stories/atoms/button/constants'
import ButtonComponent from '../../../../components/stories/atoms/button'
import TextInputComponent from '../../../../components/stories/molecules/text-input/index.jsx'
import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { createSchemas } from './form-schemas.js'
import { useEffect } from 'react'

const Login2FAForm = ({
  handleLogin,
  handleBackToLogin,
  isLoading,
  resetLoginMutations
}) => {
  const { formatMessage } = useIntl()

  // Create schemas with internationalization
  const { twoFaFormSchema } = createSchemas(formatMessage)

  const {
    register,
    handleSubmit,
    formState: { isValid },
    watch
  } = useForm({
    defaultValues: {
      twoFaCode: ''
    },
    resolver: zodResolver(twoFaFormSchema),
    mode: 'onTouched'
  })

  // Get form values for validation
  const twoFaCode = watch('twoFaCode')

  const onSubmit = (data) => isValid && handleLogin(data)

  useEffect(() => {
    resetLoginMutations()
  }, [])

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <TwofaContainer>
        <TwofaTitle>
          <FormattedMessage id={'twofa_title'} />
        </TwofaTitle>
        <TwoFaSubTitle>
          <FormattedMessage id={'twofa_sub_title'} />
        </TwoFaSubTitle>
        <TextInputComponent
          label={formatMessage({ id: 'twofa_verification_code' })}
          type="number"
          clearButton={false}
          hintShow={false}
          {...register('twoFaCode')}
        />
        <TwofaButtonsContainer>
          <ButtonComponent
            fullWidth={true}
            variant={buttonVariantOptions.PRIMARY}
            size={buttonSizeOptions.LARGE}
            type="submit"
            disabled={!isValid || !twoFaCode}
            isLoading={isLoading}
          >
            <FormattedMessage id="verify" />
          </ButtonComponent>

          <ButtonComponent
            fullWidth={true}
            variant={buttonVariantOptions['TERTIARY-HOLLOW']}
            size={buttonSizeOptions.LARGE}
            type="button"
            onClick={handleBackToLogin}
          >
            <FormattedMessage id="back_to_login" />
          </ButtonComponent>
        </TwofaButtonsContainer>
      </TwofaContainer>
    </form>
  )
}

export default Login2FAForm
